import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { Report } from '~/components';
import {
    RadioGroup,
    Select
} from '~/components/Form';
import { TypeFilters } from '~/components';
import { SelectComplete } from '~/componentslocal';


import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';
import { isEmpty } from 'lodash';
import api from '~/services/api';
import qs from 'querystring';




export default function DlgRelAfericao() {



    const [open, setOpen] = useState(true);
    const reference = useRef(null);

    const filterRef = useRef(null);

    const [post, setPost] = useState('')
    const [bicos, setBicos] = useState([])
    const [bico, setBico] = useState({})
    const [clearBico, setClearBico] = useState(false)
    const [dataObjto, setDataObjto] = useState({});


    const [tipoTypeFilters, setTipoTypeFilters] = useState(0)
    const [dataHoraInicial, setDataHoraInicial] = useState('')
    const [dataHoraFinal, setDataHoraFinal] = useState('')




    const handleGetData = useCallback((value) => {
        setTipoTypeFilters(value.tipo)
        if (value.tipo === 1) {
            setDataHoraInicial(value.datahora_inicio)
            setDataHoraFinal(value.datahora_fim)
        } else if (value.tipo == 5) {

            setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
            setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

        } else if (value.tipo == 2) {
            setDataHoraInicial(value.data_inicio + ' 00:00:00')
            setDataHoraFinal(value.data_fim + ' 23:59:59')
        }
        setDataObjto(value);
    }, [filterRef]);

    const schemaDataHora = Yup.object().shape({
        datahora_inicio: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        datahora_fim: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyDataTurno = Yup.object().shape({
        data_inicio_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
    });

    const handleValidate = useCallback(async (data) => {
        try {

            if (tipoTypeFilters == 1) {
                await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
                    abortEarly: false,
                });
            } else if (tipoTypeFilters == 5) {
                await schemaOnlyDataTurno.validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, posto: post.post_cod_posto }, {
                    abortEarly: false,
                });
            }
            filterRef.current.setErrors({})

        } catch (err) {
            console.log(err)
            const form = {};

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    form[error.path] = error.message.replace(`${error.path} `, '');
                });
                filterRef.current.setErrors(form);

            }
            throw err;
        }
    }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])


    const handleSerializeForm = useCallback((param) => {

        return {
            ...param,
            post_cod_posto: post.post_cod_posto ? post.post_cod_posto : '',
            posto_str: post.post_desc ? post.post_desc : '',
            turn_datahora_ini: dataHoraInicial,
            turn_datahora_fim: dataHoraFinal,
            bico: param.bico ?? '',
            idtarefapath: "dlgRelAfericao.swf"
        }

    }, [dataHoraInicial, dataHoraFinal, post])

    const handleGetBicos = useCallback(async () => {
        let params = {
            wherefield: 'POST_COD_POSTO',
            valuewherefield: post.post_cod_posto,
            typewherefield: 'EQUALS'
        }
        const response = await api.get('bicosposto', {
            params: { ...params, pagesize: 99999 },
            paramsSerializer: (param) => qs.stringify(param),
        });
        if (!isEmpty(response.data.items)) {
            let tempArray = response.data.items.map((item) => {
                return { label: item.bico_desc, value: item.bico_cod_bico }
            })

            setBicos(response.data.items)

        } else {
            setBicos([])
        }


    }, [post])

    useEffect(() => {
        handleGetBicos()
    }, [post])




    return (
        <>
            <Report
                ref={reference}
                open={open}
                onClose={() => setOpen(false)}
                title="RELATÓRIO DE AFERIÇÃO"
                relatorio="AFERICAO"
                validate={handleValidate}
                serialize={(param) => handleSerializeForm(param)}
            >

                <SelectComplete
                    name="posto"
                    title="Posto"
                    label="post_desc"
                    unique="post_cod_posto"
                    url="usuarioposto"
                    getValue={(value) => {
                        setPost(value);
                        setClearBico(true)
                    }}
                />



                <TypeFilters
                    ref={filterRef}
                    initials={{
                        tipo: 1,
                        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
                        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
                    }}
                    name="filtroData"
                    numberOfYears={9}
                    options={[
                        { label: t('s.geral.filtro.periododatahora'), value: 1 },
                        { label: t('s.geral.filtro.turno'), value: 5 },
                    ]}
                    onCallback={handleGetData}
                    initialURL="/turno/getturnosinicio"
                    finalURL="/turno/getturnosfim"
                    code={post.post_cod_posto}
                />
                <SelectComplete
                    name="bico"
                    label="bico_desc"
                    title="Bico"
                    unique="bico_cod_bico"
                    dataArray={bicos}
                    clearField={clearBico}
                    getValue={(value) => {
                        setClearBico(false)
                        setBico(value)
                    }}
                    disableClearable={!bico.bico_cod_bico}
                />
                <RadioGroup
                    name="tipo"
                    label="Formato"
                    options={[
                        { label: 'PDF', value: 'pdf' },
                        { label: 'Excel', value: 'xls' },
                    ]}
                    defaultValue="pdf"
                    serialize={(value) => value}
                    row
                />

            </Report>
        </>

    )
}
